<template>
  <b-form-group
    label="Ülke"
    label-for="id_countries"
  >
    <validation-provider
      #default="{ errors }"
      name="Ülke"
      rules="required"
    >
      <v-select
        id="id_countries"
        v-model="dataItem.id_countries"
        :options="countries"
        label="title"
        :reduce="country => country.id"
        placeholder="Seçiniz"
        @input="getCities"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'Company',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customerAddresses/dataItem']
    },
    countries() {
      return this.$store.getters['countries/dataList']
    },
  },
  created() {
    this.getCountries()
    localize('tr')
  },
  mounted() {
    this.getCities()
  },
  methods: {
    getCountries() {
      this.$store.dispatch('countries/getDataList', {
        select: [
          'params.id AS id',
          'params.title AS title',
        ],
        order_by: ['params.id', 'ASC'],
      })
    },
    getCities() {
      // this.dataItem.id_cities = this.dataItem.id_cities ? null : this.dataItem.id_cities
      if (this.dataItem.id_countries) {
        this.$store.dispatch('cities/getDataList', {
          select: [
            'params.id AS id',
            'params.title AS title',
          ],
          where: {
            'params.int_value_1': this.dataItem.id_countries,
          },
        })
      }
    },
  },
}
</script>
